import {post, get} from "./index"

// 轮播
export function swiper() {
  return get("/pcIndex/bannerList")
}

// 首页新闻分类，轮播下的
export function newType() {
  return get("/pcIndex/newsArticlesList")
}

// 新闻分类
export function newSort() {
  return get("/pcIndex/newsArticlesListTypeList")
}
// 新闻详情
export function newDetail(pramas) {
  return get("/pc/newsArticlesDetail?"+pramas)
}
// 活动招募
export function hotClass() {
  return get("/pcIndex/ActivityList")
}
// 统计数据
export function statisc() {
  return get("/pcIndex/workreportPcData")
}
// 新闻列表
export function newlists(pramas) {
  return get("/pc/newsArticlesPageListByType?"+pramas)
}
// 地区查询
export function areaList(pramas) {
  return get("/pc/areaList?"+pramas)
}
// 申请的提交
export function applySubmit(pramas) {
  return post("/pc/addApplicationPc",pramas)
}

export function downLoad(pramas,type) {
  return post("/admin/dowloadPdf?"+pramas,type)
}




// WEBPACK FOOTER //
// ./src/api/home.js